export const SPOTLIGHT_ID = 'proforma-meatball-changeboarding-spotlight';
export const SPOTLIGHT_TARGET_ID = 'proforma-meatball-changeboarding-spotlight-target';